module.exports = __webpack_public_path__ + "static/media/hindi_aditi.994af511.mp3";